import type { Trade } from 'utils/shared/trades/types';

/**
 * Whether the producer actually solved this quote's option model.
 *
 * A traded option cannot have an implied volatility of zero. When the model does
 * not converge — a deep-in-the-money print changing hands at intrinsic with no
 * time value left, or a row whose spot and strike disagree — the feed writes `0`
 * across implied vol and every greek rather than null, and leaves the enrichment
 * fields empty.
 *
 * Those zeros are missing data wearing a real value's clothes. Reporting them
 * turns "we have no greeks for this trade" into "this position carries no
 * exposure", which is the opposite of the truth for the prints it happens to
 * hit: they skew heavily toward the largest, deepest-in-the-money contracts.
 *
 * Implied vol is the reliable tell. A real zero delta exists (far out of the
 * money) and must be preserved; a real zero implied vol does not.
 */
export const hasSolvedGreeks = (trade: Pick<Trade, 'impliedVol'>): boolean => {
  const impliedVol = Number(trade.impliedVol);

  return Number.isFinite(impliedVol) && impliedVol > 0;
};

export default hasSolvedGreeks;
